import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import ImageVideoBlock from './ImageVideoBlock'
import GalleryStackBlock from './GalleryStackBlock'
import TextBlock from './TextBlock'
import TextSectionsBlock from './TextSectionsBlock'
import React from 'react'

// Dynamically imported (without ssr: false) so react-multi-carousel/
// react-slick code-split into their own chunks instead of shipping in
// every page that renders <Blocks>. These render real, SEO-relevant
// content, so SSR is kept -- don't add ssr: false here.
const GallerySliderBlock = dynamic(() => import('./GallerySliderBlock'))
const SlideshowBlock = dynamic(() => import('./SlideshowBlock'))

function Blocks({ postType = '', children = {}, ...rest }) {
  if (!postType && !children) return null

  const imageVideoBlock = 'AcfBlocksContentBlocksImageVideoLayout'
  const galleryBlock = 'AcfBlocksContentBlocksGalleryLayout'
  const textBlock = 'AcfBlocksContentBlocksTextLayout'
  const textSectionsBlock = 'AcfBlocksContentBlocksTextSectionsLayout'
  const slideshowBlock = 'AcfBlocksContentBlocksSlideshowLayout'

  const blockType = (block) => {
    switch (block.__typename) {
      case imageVideoBlock:
        return {
          classPrefix: 'gallery',
          component: ImageVideoBlock,
        }
      case galleryBlock:
        return {
          classPrefix: 'gallery',
          component:
            block.galleryStyle === 'stack'
              ? GalleryStackBlock
              : GallerySliderBlock,
        }
      case textBlock:
        return {
          classPrefix: 'text',
          component: TextBlock,
        }
      case textSectionsBlock:
        return {
          classPrefix: 'sections',
          component: TextSectionsBlock,
        }
      case slideshowBlock:
        return {
          classPrefix: 'slideshow',
          component: SlideshowBlock,
        }
      default:
        return null
    }
  }

  return (children.contentBlocks || []).map((child, i) => {
    // console.log('child: ', child)
    if (!child) return null
    const getBlockType = blockType(child)
    if (!getBlockType) return null
    const component = React.createElement(getBlockType.component, {
      ...child,
      key: i,
      ...rest,
    })
    return (
      <div
        key={i}
        className={`${getBlockType.classPrefix}Block
        `}
      >
        {component}
      </div>
    )
  })
}

Blocks.propTypes = {
  postType: PropTypes.string,
  children: PropTypes.object,
  rest: PropTypes.object,
}

export default Blocks
